export default __webpack_public_path__ + "static/media/08.51198f9d.jpg";